import { Outlet, Link } from "react-router-dom";
import { Box, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@frontegg/react";
import { useTranslation } from "react-i18next";
import { useLogoForScheme } from "utils/themeContextHelper";
import AppFooter from "../nav/AppFooter";
import { useBrandingContext } from "context/BrandingContext";

export default function Layout({
  showFooter = false,
  alignTop = false,
  children,
}: {
  showFooter?: boolean;
  /** Pin the content under the header, for a page whose height changes as it is used. */
  alignTop?: boolean;
  children?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();
  const { platform } = useBrandingContext();
  const logo = useLogoForScheme();
  const footerDisclosure =
    platform?.footerDisclosure || t("PlatformFooterText");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "var(--color-bg-page)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: "var(--space-7) var(--space-5)",
        }}
      >
        <Link to="/">
          <Box
            component="img"
            src={logo}
            alt={t("Company Logo")}
            sx={{ height: 40, width: "auto", maxWidth: 200 }}
            draggable={false}
          />
        </Link>
        {user ? (
          <Button
            variant="default-outlined"
            onClick={() => {
              navigate("/logout");
            }}
          >
            {t("Logout")}
          </Button>
        ) : (
          <Button
            variant="default-outlined"
            onClick={() => {
              navigate("/oauth/account/login");
            }}
          >
            {t("Login")}
          </Button>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          alignItems: alignTop ? "flex-start" : "center",
        }}
      >
        <Container maxWidth="lg">{children ?? <Outlet />}</Container>
      </Box>

      {showFooter && (
        <AppFooter
          disclosure={footerDisclosure}
          bg="var(--color-bg-page)"
          sticky={false}
        />
      )}
    </Box>
  );
}
